<svg width="443" height="275" viewBox="0 0 443 275" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M443 275H0V0H443V275ZM73 48C66.3726 48 61 53.3726 61 60V214C61 220.627 66.3726 226 73 226H370C376.627 226 382 220.627 382 214V79C382 72.3726 376.627 67 370 67H168.661C164.25 67 160.194 64.5796 158.1 60.6973L154.65 54.3027C152.556 50.4204 148.5 48 144.089 48H73Z" fill="black"/>
</svg>
